import {stringify} from "comment-json";
import {ElementsTree} from "../../../../model/ElementsTree";
import {Graph} from "../../../../model/Graph";
import {Playshot} from "../../../../model/Playshot";
import {getNodeIdFromProophBoardDescription} from "../../descriptions";
import {PlayshotChanged} from "../PlayshotChanged";
import {PlayInformationRegistry} from "./information-definitions";
import {InformationAdded} from "./InformationAdded";
import {prepareDiffInformation} from "./prepare-diff-information";
import {InformationMetadataChanged} from "./InformationMetadataChanged";
import {fqcnWithDefaultService} from "../../../cody-wizard/node/fqcn";
import {CommandRenamed} from "../commands/CommandRenamed";
import {InformationRenamed} from "./InformationRenamed";
import {InformationRemoved} from "./InformationRemoved";

export const compareInformation = (oldPlayshot: Playshot, newPlayshot: Playshot, graph: Graph, elementsTree: ElementsTree): PlayshotChanged[] => {
  const oldTypes: PlayInformationRegistry = oldPlayshot.playConfig.types;
  const newTypes: PlayInformationRegistry = newPlayshot.playConfig.types;

  const changeSet: PlayshotChanged[] = [];

  const oldNames = Object.keys(oldTypes);
  const newNames = Object.keys(newTypes);

  const informationToRemove: string[] = oldNames.filter(oldName => !newNames.includes(oldName));
  const informationToAdd: string[] = newNames.filter(newName => !oldNames.includes(newName));

  const changedInformation: string[] = newNames.filter(newName => {
    if(informationToAdd.includes(newName)) {
      return false;
    }

    const oldInformation = oldTypes[newName];
    const newInformation = newTypes[newName];

    const oldPreparedInformation = prepareDiffInformation(oldInformation, oldPlayshot);
    const newPreparedInformation = prepareDiffInformation(newInformation, newPlayshot);

    return stringify(oldPreparedInformation) !== stringify(newPreparedInformation);
  })

  informationToAdd.forEach(infoNameToAdd => {
    const infoToAdd = newTypes[infoNameToAdd];

    const existingNode = graph.getNode(getNodeIdFromProophBoardDescription(infoToAdd.desc));

    if(existingNode) {
      const oldName = fqcnWithDefaultService(existingNode, oldPlayshot.playConfig.defaultService);

      const oldInfo = oldPlayshot.playConfig.types[oldName];

      if(oldInfo) {
        changeSet.push(new InformationRenamed(infoNameToAdd, getNodeIdFromProophBoardDescription(infoToAdd.desc), infoToAdd, oldInfo, newPlayshot, oldPlayshot));
        return;
      }
    }

    changeSet.push(new InformationAdded(infoNameToAdd, getNodeIdFromProophBoardDescription(infoToAdd.desc), infoToAdd, newPlayshot));
  })

  changedInformation.forEach(infoNameToUpdate => {
    const infoToUpdate = newTypes[infoNameToUpdate];

    changeSet.push(new InformationMetadataChanged(infoNameToUpdate, getNodeIdFromProophBoardDescription(infoToUpdate.desc), infoToUpdate, newPlayshot, oldPlayshot));
  });

  informationToRemove.forEach(infoNameToRemove => {
    const infoToRemove = oldTypes[infoNameToRemove];

    changeSet.push(new InformationRemoved(infoNameToRemove, getNodeIdFromProophBoardDescription(infoToRemove.desc), infoToRemove, oldPlayshot));
  })

  return changeSet;
}
